import { render, staticRenderFns } from "./revisarRectificaciones.vue?vue&type=template&id=5ce04cd4&scoped=true"
import script from "./revisarRectificaciones.vue?vue&type=script&lang=js"
export * from "./revisarRectificaciones.vue?vue&type=script&lang=js"
import style0 from "./revisarRectificaciones.vue?vue&type=style&index=0&id=5ce04cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce04cd4",
  null
  
)

export default component.exports